import {
	IColumn,
	ILayerQueryResult,
	ILayerQueryService,
	IRequestAndCancel,
	ISMapQueryResult
} from "../services/layer_query";
import {LTServices} from "../lt-ng/lt-services";
import {L} from "../lt-ng/landcare-toolkit";
import {_F} from "../utility/func";
import {IMapShare, IMapShareService} from "../services/MapShareAPI";
import {DataTable} from "../utility/DataTable";
import {IToastService} from "../services/ToastService";
import {ILegendResponse, ILegendService} from "../services/legend";
import {ICoordinateAdjustmentService} from "../services/coordinate-adjustment";
import {IBarChartCompactDataRow} from "../directives/visualisation/bar-chart-compact";
import {IFeaturesScope} from "./features";
import {IFeatureState} from "../services/feature_state";
import {ISavedFeatureService} from "../services/features-api/saved_features";
import {IReportService} from "../services/features-api/report_service";
import {debounce} from "../utility/debounce";
import {FeaturesEvents} from "../services/events/FeaturesEvents";
import {Geometry, MultiPolygon, Polygon} from "ol/geom";
import IMapService = LTServices.IMapService;
import Item = L.tree.Item;
import filterNodes = L.tree.filterNodes;
import getVisibleScienceLayers = L.tree.getVisibleScienceLayers;
import isQueryAble = L.tree.isQueryAble;
import Resolutions = L.util.Resolutions;
import getLayerName = L.tree.getLayerName;
import {ReportServiceEvents} from "../services/features-api/report_service_events";
import {Feature} from "ol";
import {AreaReportFeatureKind, ReportKind} from "../services/ISharedFeatureState";

/**
 * Scope for AreaQueryCtrl
 */
export interface IAreaReportScope extends IFeaturesScope {
	retryQuery: () => void;
	featuresHaveFields: () => boolean;
	features: Feature<Geometry>[];
	creatingReport: boolean;
	featureIsVisible: () => boolean;
	toggleFeatureVisibility: () => void;
	updateExtent: () => void;
    generateReport();
	reportSourceLayer(): Item;
	featureType() : string;
	// General state
    queryLoading: boolean;
	anyLoading(): boolean;
	hasData(): boolean;
	anyError(): boolean;
	// Attributes of the data
    approximateArea(): number;
	featureName(): string;
	totalQueryArea: number;
    dataForPreviewChart: IBarChartCompactDataRow[];
	reportData: ILayerQueryResult|ISMapQueryResult;
	instructions: string;
	isLayerSuitableForQueryingActiveScienceLayer: (item: L.tree.Item) => boolean;
	activeContextLayer: Item;
	queryableLayers: Item[];
	visibleScienceLayersNames: () => string;
	activeLayerNotQueryable: () => boolean;
	noActiveLayers: () => boolean;
	showNode: (layerId: number) => void;
	extentQuery : boolean;
	areaQuery: IRequestAndCancel<ILayerQueryResult>;
	queryGeometry: Geometry;
	queryMapExtent : () => void;
	redoQuery: () => void;

	percentFormat: (proportion : number) => string;
	errorMessage: string;
	errorClass: string;
	reset: () => void;

	doShare: () => void;
	activeLayer: Item;
	scienceLayerName() : string;
	visibleScienceLayers() : Item[];
	scienceLayers() : Item[];
	legendData: ILegendResponse;
	zoomTo();
	showChart();
	areaQueryDisabledAtThisZoomLevel() : boolean;
	areaQueryDisabledForThisCombinationOfLayers(): boolean;
	isPickFeatureInteractionActive(): boolean;
	isExtentReport: () => boolean;
	isPredefinedFeatureReport(): boolean;
    toggleActiveLayer();
    showFeatureAttributes: boolean;
    toggleFeatureAttributes: () => boolean;
    reportOpen: boolean;
    siblingsOpen: boolean;
}

export class AreaReportCtrl {
	public static $inject = [
		'$scope',
		'layerQueryService',
		'landcareMapService',
		'mapShareService',
		'toastService',
		'$http',
		'legendService',
		'coordinateAdjustmentService',
		'featureState',
		'savedFeatureService',
		'reportService'
	];

	constructor(protected $scope : IAreaReportScope,
				protected layerQueryService : ILayerQueryService,
				protected mapService : IMapService,
				protected mapShareService : IMapShareService,
				protected toastService: IToastService,
				protected $http: ng.IHttpService,
				protected legendService: ILegendService,
				protected coordinateAdjustmentService: ICoordinateAdjustmentService,
				protected featureState: IFeatureState,
				protected savedFeatureService: ISavedFeatureService,
				protected reportService: IReportService) {
		$scope.legendData = null;
		$scope.areaQuery = null;
		$scope.queryLoading = false;
		$scope.activeLayer = null;
		$scope.totalQueryArea = undefined;
		$scope.siblingsOpen = $scope.reportOpen = true;
		$scope.features = [];

		$scope.anyLoading = () => $scope.queryLoading || $scope.sharedState().featureLoading;

		/*$scope.layerPickerActive = false;
		$scope.$on('closeLayerPicker', () => $scope.layerPickerActive = false);*/

		$scope.featureType = () => {
            let activeReport = this.featureState.sharedState().activeReport;
            if (activeReport.kind == ReportKind.area && activeReport.featureKind == AreaReportFeatureKind.predefined) {
            	let source = activeReport.sourceLayer;
            	return source.name;
			}
			return '';
		};

		$scope.isPickFeatureInteractionActive = () => this.featureState.isPickFeatureInteractionActive();

		$scope.featureName = () => {
			return this.featureState.defaultTitleForReport();
		};


		let reportInstance = null;
		let reportInstanceIsForLayers: string = null;

		$scope.$on(ReportServiceEvents.reportDeleted, (ev, rp) => {
			if (reportInstance && rp && reportInstance.id === rp.id) {
				reportInstance = null;
				reportInstanceIsForLayers = null;
			}
		})

		let showFragReport = () => {
			console.log(reportInstance);
			if (reportInstance && reportInstance['id']) {
                let id = reportInstance['id'];
                $scope.$emit('showFragReport', id, true);
			}
		};

		$scope.creatingReport = false;
		$scope.generateReport = debounce(() => {
			$scope.creatingReport = true;
			$scope.saveFeatureReport().then(() => {
                let rp = this.featureState.getActiveReportIfArea();
                let subject = rp && rp.userFeatures && rp.userFeatures.userFeature;
                if (!subject) return;

				let layerNames = this.featureState.getScienceLayersForAreaQuery().map(l => l.layerService.layerName)
					.sort().join(',');

				if (reportInstance
						&& reportInstance['subject']
						&& reportInstance['subject']['id'] == subject.id
						&& reportInstanceIsForLayers == layerNames) {
					showFragReport();
					return;

                }

                return this.reportService.createReportForName(subject, 'area_report', subject.title, layerNames)
                    .then(report => {
                        console.log(report);
                        reportInstanceIsForLayers = layerNames;
                        reportInstance = report;
                        showFragReport();
                    }, () => {
                        reportInstance = null;
                    });
			}).finally(() => {
				$scope.creatingReport = false;
			});
		}, 750, true);

		$scope.approximateArea = () => {
			if (typeof $scope.totalQueryArea === 'number') {
				return $scope.totalQueryArea / 10_000;
			}

			let rp = featureState.getActiveReportIfArea();

			if (!rp || !rp.features.length) return undefined;

			const m2 = rp.features
				.map(f => f.getGeometry())
				.filter((g): g is (Polygon|MultiPolygon) => {
					return (g instanceof Polygon)
						|| (g instanceof MultiPolygon);
				})
				.map(g => g.getArea())
				.reduce((a, b) => a + b, 0);
			return m2 / 10_000;
		};

		$scope.anyError = () => {
			return !!$scope.errorMessage
				|| $scope.areaQueryDisabledForThisCombinationOfLayers();
		};

		$scope.areaQueryDisabledForThisCombinationOfLayers = () => {
			return false;
		};

		$scope.zoomTo = () => {
			let map = mapService.map;

			if ($scope.sharedState().activeReport) {
				let extent = mapService.featuresLayer.getSource().getExtent();

				map.getView().fit(extent,
					<any> { // Typings are out of date....
						size: map.getSize(),
						padding: this.coordinateAdjustmentService.padding([10, 10, 10, 10])
					});
			}
		};

		$scope.featuresHaveFields = () => {
			const rp = featureState.getActiveReportIfArea();
			if (!rp) return false;

			return rp.features.some(f => Array.isArray(f.get('fields')));
		}

		$scope.scienceLayerName = () : string => {
			// return areaQueryService.queriedLayers.map((l) => l.name).join(" / ");
			try {
				let rp = $scope.sharedState().activeReport;
				if (!rp) return '';

				let currentData = this.featureState.getAreaQueryResultsForCurrentScienceLayer();
				if (rp.kind == ReportKind.area && currentData) {
                    return currentData.queriedLayers.map((n) => n.name).join(" / ");
				}
			} catch (e) {

            }
			return '';
		};

        $scope.areaQueryDisabledAtThisZoomLevel = () => {
            let map = mapService.map;
            let visibleLayers = $scope.visibleScienceLayers();

            if (visibleLayers.length && map) {
                let currentScale = Resolutions.scaleFromResolution(map.getView().getResolution());
                return visibleLayers.some((n) => {
                    return n.layerService && n.layerService.minScale > currentScale;
                });
            }
            return false;
        };

		let propertiesTable = new DataTable<object>([], 'Class');
		propertiesTable.setColumnCompareFn('Class', (a, b) => Number(a) - Number(b));
		propertiesTable.sortColumn = 'Class';


		$scope.dataForPreviewChart = [];

		let mapShare = null;
		let mapShareResult = null;

		$scope.$on('resetAreaQueryShare', () => {
			mapShareResult = null
		});

		let clickInteraction = null;

		$scope.reset = () => {
			$scope.backToStart();
		};

		$scope.doShare = () => {
			if (mapShare) {
				if (mapShareResult) {
					$scope.$root.$broadcast('showShareModal', mapShareResult);
				} else {
					mapShareService.createAreaReportShare(mapShare).then((result : IMapShare) => {
						mapShareResult = result;
						$scope.$root.$broadcast('showShareModal', result);
					});
				}
			}
		};

        let nameValueToObject = (data: IColumn[]): object => {
            let out = {};
            data.forEach((col: IColumn) => {
                out[col.name] = col.value;
            });
            return out;
        };

        let rowColumnsToObject = (result : ILayerQueryResult) : object[] => {
            let layers = result.response.layers || [];
            return layers.map((layer) => {
                return layer.rows.map((row) => nameValueToObject(row.columns))
            }).reduce((x,y) => x.concat(y), []);
        };

		let retry: () => void = undefined;

        let displaySMapResults = (layer: Item, smapData: ISMapQueryResult) => {
        	let layerService = layer.layerService;
			let colours = {};
            layerService.CLASS.forEach((cls) => {
            	colours[cls.param] = cls.classColor;
			});

            try {
                $scope.dataForPreviewChart = smapData.response.soils.map(d => {
                    return {
                        value: d.area,
                        color: colours[d.classNo-1],
                        description: d.description
                    }
                });

            } catch (e) {
                $scope.dataForPreviewChart = [];
            }

            $scope.totalQueryArea = smapData.response.totalArea;

            // $scope.errorMessage = $scope.dataForPreviewChart.length ? '' : 'No data available';
			$scope.errorMessage = '';

            $scope.instructions = '';
            if (clickInteraction && clickInteraction.getActive()) {
                $scope.instructions = clickInteraction.get('help') || '';
            }


            this.legendService.getLegendForNodes([layer]).then((result) => {
                $scope.legendData = result.data;
                smapData.response.soils.forEach((item) => {
                    $scope.legendData.response.filter((i) => {
                        return i.shortName == item.description || i.param == item.classNo-1;
                    }).forEach((result) => {
                        item['longDescription'] = result.longName;
                    })
                });
            });
        };

        let displayReport = () => {
			console.log('displayReport');

			$scope.queryLoading = true;
			let report = this.featureState.sharedState().activeReport;
			if (!report || report.kind != ReportKind.area) {
				$scope.reportData = null;
				$scope.dataForPreviewChart = [];
				$scope.queryLoading = false;
				return;
			}

			$scope.features = report.features

			const request = this.featureState.getAreaQueryResultsForCurrentScienceLayer();

			if (!request) {
				$scope.reportData = null;
				$scope.dataForPreviewChart = [];
				$scope.queryLoading = false;
				return;
			}

			retry = request.request.retry;
			const revision = report.kind === ReportKind.area && report.revision;

            mapShare = mapShareService.createFeaturesSharePaylod(report.features);
            let activeLayerKey = featureState.activeScienceLayersKey();

			// Need better names
			request.request.request.then((data : ILayerQueryResult|ISMapQueryResult) => {
				/* check if the active report has changed...
				 * and don't do anything if the report this data is for is no longer active
 				 */
				const activeReport = $scope.sharedState().activeReport;
				if (report != activeReport) return;

				const currentRevision = activeReport && activeReport.kind === ReportKind.area && activeReport.revision;
				if (revision < currentRevision) {
					console.log('old revision');
					return; // don't update the UI if the current revision is newer
				}

				let currentLayerKey = this.featureState.activeScienceLayersKey();

                /**
				 * If the science layers were switched while the report was loading,
				 * this data shouldn't be displayed.
                 */
				if (activeLayerKey != currentLayerKey) {
					return;
				}

				$scope.reportData = data;
				$scope.activeLayer = this.featureState.getScienceLayersForAreaQuery()[0];

				this.$scope.$broadcast('areaReport:newResults', data);

				$scope.queryLoading = false;

				let layers = $scope.visibleScienceLayers().map(getLayerName);
				if ('soils' in data.response) {
					let currentLayer = this.featureState.reportingLayers()[0];
					displaySMapResults(currentLayer, <ISMapQueryResult> data);
					return;
				}

				let layerQueryResult = <ILayerQueryResult> data;
				// Sort the layers in the data so they appear in the same order
				// as the layer names do in the report preview title.
                layerQueryResult.response.layers.sort((a, b) => {
					return layers.indexOf(a.name) - layers.indexOf(b.name);
				});

                let flattenedData = rowColumnsToObject(layerQueryResult)
                    .filter((r) => r['Class Area'] !== undefined)
                    .filter((r) => r['Class Flags Hash']['VISUALISATION']);


                try {
                    $scope.dataForPreviewChart = flattenedData.map(d => {
                        return {
                            value: d['Class Area'],
                            color: d['Class Color'],
                            description: d['Class Description']
                        }
                    });

                } catch (e) {
                    $scope.dataForPreviewChart = [];
                }

                $scope.totalQueryArea = layerQueryResult.response.area;

                $scope.errorMessage = '';

                $scope.instructions = '';
                if (clickInteraction && clickInteraction.getActive()) {
                    $scope.instructions = clickInteraction.get('help') || '';
                }


                this.legendService.getLegendForNodes(request.queriedLayers).then((result) => {
                    $scope.legendData = result.data;
                    rowColumnsToObject(layerQueryResult).forEach((item: any) => {
                        $scope.legendData.response.filter((i) => {
                            return i.shortName == item['Class Description'] || i.param == item['Class']-1;
                        }).forEach((result) => {
                            item['longDescription'] = result.longName;
                        })
                    });
                });
			}, (err) => {
                console.error(err);
				$scope.errorMessage = `${err}`;
				$scope.queryLoading = false;
				$scope.dataForPreviewChart = [];
			});
		};

		let handleChangedReport = () => {
            const rp = $scope.sharedState().activeReport;
            if (rp && rp.kind == ReportKind.area) {
            	$scope.errorMessage = '';
                displayReport();
            }
        };
		$scope.$watch('sharedState().activeReport', handleChangedReport);
		$scope.$watch('sharedState().activeReport.revision', handleChangedReport);
		$scope.$on(FeaturesEvents.reportChanged, handleChangedReport);

		$scope.retryQuery = () => {
			console.log('retryQuery');
			$scope.errorMessage = '';
			if (retry) retry();
			displayReport();
		}

		let currentScienceLayersKey = featureState.activeScienceLayersKey();
		$scope.$on('layerToggled', () => {
			let newKey = this.featureState.activeScienceLayersKey();
			console.log(`Keys: new ${newKey}, old: ${currentScienceLayersKey}`);

			if (newKey != currentScienceLayersKey) {
				currentScienceLayersKey = newKey;

                const rp = $scope.sharedState().activeReport;
                if (rp && rp.kind == ReportKind.area) {
                    displayReport();
                }
			}
		});

		$scope.isLayerSuitableForQueryingActiveScienceLayer = (item: Item) => {
            return !$scope.visibleScienceLayers()
				.some((l) => {
					let ls = l.layerService;
					if (ls.cantBeQueriedWithTheseLayers) {
						return ls.cantBeQueriedWithTheseLayers.some((id) => id == item.layerId);
					}
					return false;
				});
		};

		$scope.$watch('sharedState().featureLoading', () => {
			console.log(`sharedState().featureLoading: ${$scope.sharedState().featureLoading}`);
		});

		$scope.percentFormat = (proportion : number) : string => {
			return _F.percentFormat(proportion);
		};

		$scope.visibleScienceLayers = () => getVisibleScienceLayers(mapService.treeData).filter(isQueryAble);

		$scope.visibleScienceLayersNames = () => {
			return ($scope.visibleScienceLayers() || []).map((v) => v.name).join(' / ');
		};

		$scope.noActiveLayers = () => getVisibleScienceLayers(mapService.treeData).length === 0;
		$scope.activeLayerNotQueryable = () => {
			const activeLayers = getVisibleScienceLayers(mapService.treeData);
			return activeLayers.length && !activeLayers.some(isQueryAble);
		}

		$scope.scienceLayers = () => {
			return this.featureState.getScienceLayersForAreaQuery();
			// return getIncludedScienceLayers(mapService.treeData).filter(isQueryAble);
		};

		$scope.showNode = (layerId: number) => {
			if (layerId) {
				let candidates = filterNodes(mapService.treeData, (item) => item['layerService'] && item['layerService']['id'] === layerId);
				if (candidates.length) {
					candidates[0].checked = true;
					$scope['showSelected'](candidates[0], true, false);
				}
			}
		};

		$scope.showChart = () => {
			$scope.$root.$broadcast('showModal', 'Charts', false);
		};

		$scope.isExtentReport = () => {
			return !!this.featureState.getActiveReportIfExtent();
		};

		$scope.updateExtent = () => {
			this.featureState.queryExtent();
		};

		$scope.toggleFeatureVisibility = () => {
			const isVis = $scope.featureIsVisible();
			this.featureState.getActiveReportIfArea().features.forEach(f => f.set('hidden', isVis));
		};

		$scope.featureIsVisible = () => {
			return this.featureState.getActiveReportIfArea().features.some(f => !f.get('hidden'));
		};

		$scope.isPredefinedFeatureReport = () => {
			return !!this.featureState.getActiveReportIfPredefined();
		};

		$scope.reportSourceLayer = () => {
			let rp = this.featureState.getActiveReportIfPredefined();
			return rp && rp.sourceLayer;
		};

		$scope.toggleActiveLayer = () => {
			this.featureState.toggleSourceLayer();
		};

		$scope.showFeatureAttributes = false;
		$scope.toggleFeatureAttributes = () => $scope.showFeatureAttributes = !$scope.showFeatureAttributes;
	}
}
